<script lang="ts" setup>
  import { onMounted } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { Routes } from '@/const/Routes'

  import AppLayout from '@/components/layout/AppLayout.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import Typography from '@/components/common/Typography.vue'
  import { KsButton } from '@aschehoug/kloss'
  import ImageWithCaption from '@/components/common/ImageWithCaption.vue'

  const { t } = useI18n()

  onMounted(() => sessionStorage.removeItem('route-before-login'))
</script>

<template>
  <StandardLayout>
    <AppLayout>
      <div class="wrapper">
        <ImageWithCaption
          src="/404.webp"
          alt-text="Bilde av et tomt klasserom"
          copyright="Foto av Guilia Squillace / Unsplash+"
          class="image"
        />

        <Typography component="h1" variant="h2">
          {{ t('notFound.title') }}
        </Typography>
        <Typography>{{ t('notFound.text') }}</Typography>
        <router-link :to="{name: Routes.Home.name}">
          <KsButton
            variant="border"
            type="label"
            shape="rounded"
          >
            {{ t('notFound.link') }}
          </KsButton>
        </router-link>
      </div>
    </AppLayout>
  </StandardLayout>
</template>

<style lang="scss" scoped>
  .wrapper {
    width: $vgs-max-width-content;
    margin: 0 auto;
    color: var(--color-blue-50);

    .image {
      margin-bottom: 42px;
    }

    .ks-button {
      border-color: var(--color-blue-50);
      color: var(--color-blue-50);
    }
  }
</style>
